import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateItemDialog.css';

const ConfirmationDialog = ({
  isOpen,
  onClose,
  title = "The Heist Framework",
  message,
  jobs = 0,
  jobPath = '',
  sequences = 0,
  shots = 0,
  applications = 0,
  isError = false
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleViewLogs = () => {
    navigate('/logs');
    onClose();
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>{title}</h3>
          <button className="dialog-close" onClick={onClose}>✕</button>
        </div>

        <div className="dialog-body">
          {!isError ? (
            <div className="confirmation-content">
              <div className="success-message">
                ✅ Successfully created folder structure:
              </div>
              {jobs > 0 && jobPath && (
                <div className="job-path-message">
                  New job created at {jobPath}
                </div>
              )}
              <div className="folder-counts">
                {jobs > 0 && (
                  <div className="count-item">
                    <span className="count-label">Jobs:</span>
                    <span className="count-number">{jobs}</span>
                  </div>
                )}
                <div className="count-item">
                  <span className="count-label">Sequences:</span>
                  <span className="count-number">{sequences}</span>
                </div>
                <div className="count-item">
                  <span className="count-label">Shots:</span>
                  <span className="count-number">{shots}</span>
                </div>
                <div className="count-item">
                  <span className="count-label">App Folders:</span>
                  <span className="count-number">{applications}</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="error-content">
              <div className="error-message">
                ❌ {message || "Failed to create folder structure"}
              </div>
            </div>
          )}
          
          <div className="dialog-buttons">
            <button type="button" onClick={handleViewLogs} className="btn-secondary">
              View Logs
            </button>
            <button type="button" onClick={onClose} className="btn-confirm">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;